module.exports = __webpack_public_path__ + "img/1731378730112  2段下 (2).2151fa94.png";